import { PeopleSearchProfile } from "../../types/peopleSearch.ts";

export const PEOPLE_SEARCH_SET_WORKERS = "PEOPLE_SEARCH_SET_WORKERS";

export const setPeopleSearchWorkers = (workers: PeopleSearchProfile[]) => ({
  type: PEOPLE_SEARCH_SET_WORKERS,
  payload: workers,
});
